<template>
  <v-autocomplete
      v-model="innerValue"
      label="Unit assigned to the incident"
      :items="itemsPrepared"
      :error-messages="errorMessages"
      :loading="unitsLoading"
      outlined
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ENSURE_UNITS_LOADED } from '@/store/Neris/actions';

export default {
  name: 'UnitNerisId',
  props: {
    value: {
      type: [String, Array],
      default: '',
    },
    fieldProperties: {
      type: Object,
      required: true,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
  },
  emits: ['input', 'blur'],
  computed: {
    ...mapState('neris', ['units', 'unitsLoading']),
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    itemsPrepared() {
      if (!this.units) {
        return [];
      }
      const items = [];
      this.units.forEach(unit => {
        items.push({
          text: `${unit.stationId}: ${unit.cadDesignation1}`,
          value: unit.nerisId,
        });
      });
      return items;
    },
  },
  mounted() {
    this.ensureUnitsLoaded();
  },
  methods: {
    ...mapActions({
      ensureUnitsLoaded: `neris/${ENSURE_UNITS_LOADED}`,
    }),
  },
};
</script>
